/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.BoostStorage = {
	bundlename: Context.get("boostDict").sookiename,
	bundle: {},

	init() {
		this.Model = BoostModel;
		this.uid = CURRENTUSERID.substr(0, 8);

		this.retrieve();
		this.clean();
	},

	retrieve() {
		let bundle = Storage.getItem(this.bundlename);

		if (!bundle || (bundle === "")) {
			bundle = "{}";
		}

		try {
			bundle = JSON.parse(bundle);
		} catch (e) {
			bundle = {};
			this.reset();
			window.util.updateStats('spotlight - status - failed to eval bundle', 1, 'counter', '0OSif0XM/7gaVoSTWlq6e7gr/YQ=');
		}

		this.bundle = bundle;
	},

	reset() {
		this.bundle = {};
		this.save();
	},

	clean() {
		// clean out multi-day-old reports
		const yesterday = this.Model.getNow() - (86400*2);
		const reports = this.key("reports");
		let reportsdeleted = false;

		if (this.bundle[reports] && _(this.bundle[reports]).isObject()) {
			for (let id in this.bundle[reports]) {
				const time = this.bundle[reports][id];
				if (parseInt(time, 10) < yesterday) {
					delete this.bundle[reports][id];
					reportsdeleted = true;
				}
			}

			if (reportsdeleted) {
				this.save();
			}
		}
	},

	save() {
		const bundle = JSON.stringify(this.bundle);
		return Storage.setItem(this.bundlename, bundle);
	},

	key(key) {
		return `${this.uid}${key}`;
	},

	has(key) {
		return this.bundle[ this.key(key) ] === "1";
	},

	add(key) {
		this.bundle[ this.key(key) ] = "1";
		this.save();
	},

	remove(key) {
		delete this.bundle[ this.key[key] ];
		this.save();
	},

	hasReport(id) {
		return __guard__(this.bundle[ this.key("reports") ], x => x[id]);
	},

	addReport(id) {
		const reports = this.key("reports");

		if ((this.bundle[reports] == null) || !_(this.bundle[reports]).isObject()) {
			this.bundle[reports] = {};
		}

		this.bundle[reports][id] = this.Model.getNow();

		this.save();
	}
};

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}



// WEBPACK FOOTER //
// ./src/legacy/boosts/storage.js